import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Lock, User } from 'lucide-react';
import { Helmet } from 'react-helmet';

export default function AdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Credentials (en production, ceci devrait être géré côté backend)
  const ADMIN_USERNAME = 'admin';
  const ADMIN_PASSWORD = 'Homely2026!';

  const handleLogin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Vérification des credentials
    if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
      // Créer un token simple (en production, utiliser JWT depuis le backend)
      const token = btoa(`${username}:${Date.now()}`);
      localStorage.setItem('adminToken', token);
      localStorage.setItem('adminUser', username);
      
      // Rediriger vers la page admin
      navigate('/admin/leads');
    } else {
      setError('Identifiants incorrects');
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Connexion Administration | Homely Conciergerie</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="min-h-screen bg-gradient-to-br from-[#F5F3EF] to-[#E8EBE4] flex items-center justify-center px-6 py-12">
      <Card className="w-full max-w-md shadow-xl border-2 border-[#8A9474]/20">
        <CardHeader className="space-y-3 text-center pb-6">
          <div className="mx-auto w-16 h-16 bg-[#8A9474] rounded-full flex items-center justify-center">
            <Lock className="h-8 w-8 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold text-[#2B2B2B]">
            Accès Administration
          </CardTitle>
          <p className="text-sm text-[#6B6B6B]">
            Homely Conciergerie - Espace sécurisé
          </p>
        </CardHeader>

        <CardContent>
          <form onSubmit={handleLogin} className="space-y-5">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div className="space-y-2">
              <label className="text-sm font-medium text-[#2B2B2B] flex items-center gap-2">
                <User className="h-4 w-4 text-[#8A9474]" />
                Nom d'utilisateur
              </label>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                required
                className="border-[#8A9474]/30 focus:border-[#8A9474] h-12"
                autoComplete="username"
              />
            </div>

            <div className="space-y-2">
              <label className="text-sm font-medium text-[#2B2B2B] flex items-center gap-2">
                <Lock className="h-4 w-4 text-[#8A9474]" />
                Mot de passe
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                className="border-[#8A9474]/30 focus:border-[#8A9474] h-12"
                autoComplete="current-password"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-[#8A9474] hover:bg-[#7A8464] text-white h-12 text-base font-semibold"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>

            <div className="text-center text-xs text-[#6B6B6B] mt-4">
              Accès réservé aux administrateurs Homely Conciergerie
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
    </>
  );
}
